import type { Path } from 'react-router';
import { useAccountContext } from '@gonfalon/app-context/useAccountContext';
import { Message } from '@gonfalon/messages/Message';
import { toDiagnosticUsageDetails } from '@gonfalon/navigator/navigators';

import { AggregationType } from '../../../types';
import { useAllUsageTabData } from '../../hooks/useAllUsageTabData';
import { getSubscriptionLimits } from '../../utils/getSubscriptionLimits';
import { getVisibleDiagnosticTabs } from '../../utils/getVisibleDiagnosticTabs';
import { TotalUsageCard } from '../PlanUsageOverview/components';

import styles from '../common/UsageOverview.module.css';

type DiagnosticUsageOverviewProps = {
  detailsRedirectFn?: ({ metric }: { metric: string }) => Path;
};

export function DiagnosticUsageOverview({ detailsRedirectFn }: DiagnosticUsageOverviewProps = {}) {
  const { subscription } = useAccountContext();

  const limits = getSubscriptionLimits(subscription);
  const visibleTabs = getVisibleDiagnosticTabs(limits);
  const aggregationType = AggregationType.INCREMENTAL;
  const allUsageData = useAllUsageTabData(visibleTabs, aggregationType, { isDiagnostic: true });

  return (
    <div>
      <h2 className={styles.overviewTitle}>
        <Message id="billing.diagnosticUsageOverview.diagnosticOverview" />
      </h2>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <div className={styles.headerTitle}>
            <h3>
              <Message id="billing.diagnosticUsageOverview.monthlyAccumulatedUsage" />
            </h3>
          </div>
        </div>
      </div>
      <div className={styles.cardGrid}>
        {allUsageData?.map((usageData) => {
          const { tab, title, total, precision, aggregationType: tabAggregationType } = usageData;
          return (
            <TotalUsageCard
              key={tab}
              title={title}
              value={total}
              aggregationType={tabAggregationType}
              usageData={usageData}
              precision={precision}
              detailsRedirectFn={detailsRedirectFn || toDiagnosticUsageDetails}
              hideMarklines
            />
          );
        })}
      </div>
    </div>
  );
}
